"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./util/in-dom");
var on = function (node, eventName, handler, capture) { };
exports.on = on;
if (in_dom_1.inDOM) {
    exports.on = on = (function () {
        if (document.addEventListener) {
            return function (node, eventName, handler, capture) {
                return node.addEventListener(eventName, handler, capture || false);
            };
        }
        else if (document['attachEvent']) {
            return function (node, eventName, handler, capture) {
                return node.attachEvent('on' + eventName, handler);
            };
        }
        else {
            return on;
        }
    })();
}
var off = function (node, eventName, handler, capture) { };
exports.off = off;
if (in_dom_1.inDOM) {
    exports.off = off = (function () {
        if (document.addEventListener) {
            return function (node, eventName, handler, capture) {
                return node.removeEventListener(eventName, handler, capture || false);
            };
        }
        else if (document['attachEvent']) {
            return function (node, eventName, handler) {
                return node.detachEvent('on' + eventName, handler);
            };
        }
        else {
            return off;
        }
    })();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/events.js
// module id = 58
// module chunks = 0 1 2 3 4 5 6